import { render, staticRenderFns } from "./CompactMenu.vue?vue&type=template&id=542f802b&scoped=true"
import script from "./CompactMenu.vue?vue&type=script&lang=js"
export * from "./CompactMenu.vue?vue&type=script&lang=js"
import style0 from "./CompactMenu.vue?vue&type=style&index=0&id=542f802b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f802b",
  null
  
)

export default component.exports